import React from 'react';
import ReactDOM from 'react-dom/client';
import AppInit from 'components/App/CreateAccount/AppInit';
import {
    SetBearerTokenContext, SetParticipantContext, SetTenantContext,
    SetPublicURLContext, SetReturnURLContext, SetReCaptchaSiteKeyContext,SetPrivacyPolicyURLContext,SetTermsofUseURLContext
} from 'utilities/contexts'
import { SetCreateAccountContext } from 'utilities/contexts.createAccount'
import reportWebVitals from 'reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'animate.css';
import 'entry/CustomBootstrap.scss';
import 'entry/rfReactJS.scss';
import './index.scss';

// context setup
SetParticipantContext(document.getElementById('IsParticipant')?.value);
SetBearerTokenContext(document.getElementById('BearerToken')?.value);
SetTenantContext(document.getElementById('Tenant')?.value);
SetPublicURLContext(document.getElementById('PublicURL')?.value);
SetReturnURLContext(document.getElementById('ReturnURL')?.value);
SetReCaptchaSiteKeyContext(document.getElementById('ReCaptchaSiteKey')?.value);

SetCreateAccountContext(document.getElementById('JoinType').value, document.getElementById('ThirdPartyUserName').value);

SetPrivacyPolicyURLContext(document.getElementById('PRIACY_POLICY')?.value);
SetTermsofUseURLContext(document.getElementById('TERMS_OF_USE')?.value);

// query client setup
const queryClient = new QueryClient();

// root render
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <AppInit />
        </QueryClientProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
